import {setFeedbackStatus} from "@/redux/slices/mlSlices/chatSlice";

import React, {useCallback, useEffect} from "react";

import bellIcon from "@images/general/bell.png";
import {BorderArticle} from "@ui/general/BorderArticle";
import {RootIcon} from "@ui/icons/RootIcon";
import {AnimatePresence, motion} from "framer-motion";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation} from "react-router-dom";

import {RootDesc} from "../../descriptions/RootDesc";
import styles from "./styles.module.scss";

export const NotificationInfo = ({duration = 5000}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const {feedbackStatus} = useSelector((state) => state.ml.chat);
  const {role} = useSelector((state) => state.common.candidate);

  const handleClickClose = useCallback(() => {
    dispatch(setFeedbackStatus({state: "", session: ""}));
  }, [dispatch]);

  const isVisible = feedbackStatus.state === "completed";

  const notificationAnimation = {
    initial: {
      y: "-100%",
      x: "-50%",
      opacity: 0,
    },
    animate: {
      y: "28rem",
      x: "-50%",
      opacity: 1,
      transition: {
        duration: 0.25,
        ease: "easeOut",
      },
    },
    exit: {
      y: "-100%",
      x: "-50%",
      opacity: 0,
      transition: {
        duration: 0.25,
        ease: "easeIn",
      },
    },
  };

  const isChatGamePage = location.pathname.includes("chat");

  useEffect(() => {
    if (isChatGamePage) {
      handleClickClose();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        handleClickClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, handleClickClose]);

  if (isChatGamePage) {
    return null;
  }

  return (
    <AnimatePresence mode={"wait"}>
      {isVisible && (
        <motion.div
          key={"notification"}
          className={styles.notificationWrapper}
          initial={notificationAnimation.initial}
          animate={notificationAnimation.animate}
          exit={notificationAnimation.exit}
        >
          <BorderArticle>
            <div className={styles.notificationInfo}>
              <img
                src={bellIcon}
                alt={"bell-icon"}
              />

              <RootDesc>
                <span>
                  {t("notification_info.message")}
                  <br />
                  <Link
                    onClick={handleClickClose}
                    to={
                      role === "Representative"
                        ? `/user-panel/analytics/${feedbackStatus.session}`
                        : `/admin-panel/analytics/${feedbackStatus.session}`
                    }
                  >
                    {t("notification_info.link")}
                  </Link>
                </span>
              </RootDesc>

              <RootIcon
                width={24}
                height={24}
                id={"burger-close"}
                onClickIcon={handleClickClose}
              />
            </div>

            <div className={styles.progressBar}>
              <motion.div
                className={styles.progressBarFill}
                initial={{width: "0%"}}
                animate={{width: "100%"}}
                transition={{
                  duration: duration / 1000,
                  ease: "linear",
                }}
              />
            </div>
          </BorderArticle>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
